import { type AnyAction } from 'redux';
import { ACCESS_TOKEN_REFRESHED, LOGOUT } from '../actions/actionTypes/user';
import { SEND_REQUEST_SUCCESS } from '../actions/actionTypes/request';
import { REQUEST_TYPES } from '../../api/requests/requestTypes';
import { type AuthState } from '../types';

export const initialState: AuthState = {
    isAuthorized: false,
    accessToken: null,
    refreshToken: null,
    sessionState: null,
    scope: null
};

export const auth = (state = initialState, action: AnyAction): AuthState => {
    const { type, payload, request = {} } = action;

    switch (type) {
        case SEND_REQUEST_SUCCESS: {
            switch (request.type) {
                case REQUEST_TYPES.LOGIN: {
                    try {
                        return {
                            ...state,
                            accessToken: payload.data.token,
                            refreshToken: payload.data.refreshToken,
                            isAuthorized: true
                        };
                    } catch {
                        return { ...initialState };
                    }
                }

                default:
                    return state;
            }
        }
        case ACCESS_TOKEN_REFRESHED: {
            if (state.isAuthorized) {
                return {
                    ...state,
                    accessToken: payload.data.token
                };
            }
            return state;
        }
        case LOGOUT: {
            return { ...initialState };
        }

        default: {
            return state;
        }
    }
};
